import { useEffect, useState, useSyncExternalStore } from "react";
import TelaCarregando from "@/components/app/TelaCarregando";
import { aberturaFechada, aoMudarAbertura } from "@/lib/abertura";
import { cn } from "@/lib/utils";

/**
 * A abertura do app (/app) e do painel (/admin), desenhada pelo __root já no HTML: aparece antes do JavaScript e some
 * num fade quando o layout chama fecharAbertura(). O atributo data-app ou data-painel traz as cores de cada um.
 */
const Abertura = ({ onde }: { onde: "app" | "painel" }) => {
  const fechada = useSyncExternalStore(aoMudarAbertura, aberturaFechada, () => false);
  const [montada, setMontada] = useState(true);
  useEffect(() => {
    if (!fechada) return;
    const t = setTimeout(() => setMontada(false), 450);
    return () => clearTimeout(t);
  }, [fechada]);
  if (!montada) return null;

  return (
    <div
      {...(onde === "app" ? { "data-app": "" } : { "data-painel": "" })}
      className={cn(
        "fixed inset-0 z-[60] transition-opacity duration-[420ms] ease-out motion-reduce:transition-none",
        fechada ? "pointer-events-none opacity-0" : "opacity-100",
      )}
    >
      <TelaCarregando rotulo={onde === "app" ? "Abrindo o app" : "Abrindo o painel"} />
    </div>
  );
};

export default Abertura;
